// FETCH ALL PROPERTIES FROM COLOR MASTER
export const FETCH_COLOR_MASTER_REQUEST = 'FETCH_COLOR_MASTER_REQUEST';
export const FETCH_COLOR_MASTER_SUCCESS = 'FETCH_COLOR_MASTER_SUCCESS';
export const FETCH_COLOR_MASTER_FAILURE = 'FETCH_COLOR_MASTER_FAILURE';

// CREATE PROPERTIES FOR COLOR MASTER
export const CREATE_COLOR_MASTER_REQUEST = 'CREATE_COLOR_MASTER_REQUEST';
export const CREATE_COLOR_MASTER_SUCCESS = 'CREATE_COLOR_MASTER_SUCCESS';
export const CREATE_COLOR_MASTER_FAILURE = 'CREATE_COLOR_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_COLOR_MASTER = 'CREATE_USER_FORM_COLOR_MASTER';

// UPDATE PROPERTIES FOR COLOR MASTER
export const UPDATE_COLOR_MASTER_REQUEST = 'UPDATE_COLOR_MASTER_REQUEST';
export const UPDATE_COLOR_MASTER_SUCCESS = 'UPDATE_COLOR_MASTER_SUCCESS';
export const UPDATE_COLOR_MASTER_FAILURE = 'UPDATE_COLOR_MASTER_FAILURE';

// FETCH SINGLE COLOR
export const FETCH_SINGLE_COLOR_MASTER_REQUEST = 'FETCH_SINGLE_COLOR_MASTER_REQUEST';
export const FETCH_SINGLE_COLOR_MASTER_SUCCESS = 'FETCH_SINGLE_COLOR_MASTER_SUCCESS';
export const FETCH_SINGLE_COLOR_MASTER_FAILURE = 'FETCH_SINGLE_COLOR_MASTER_FAILURE';

// DELETE PROPERTIES FOR COLOR MASTER
export const DELETE_COLOR_MASTER_REQUEST = 'DELETE_COLOR_MASTER_REQUEST';
export const DELETE_COLOR_MASTER_SUCCESS = 'DELETE_COLOR_MASTER_SUCCESS';
export const DELETE_COLOR_MASTER_FAILURE = 'DELETE_COLOR_MASTER_FAILURE';

//RESET FORM OF USER
export const RESET_USER_FORM_COLOR_MASTER = 'RESET_USER_FORM_COLOR_MASTER';

// navigate to Color Details Component
export const NAVIGATE_COLOR_DETAIL = 'NAVIGATE_COLOR_DETAIL';
// navigate to Color Master Component
export const NAVIGATE_COLOR_MASTER = 'NAVIGATE_COLOR_MASTER';
